import { cacheClient, clientConfig } from '@api-client/redis';
import { singleton } from '@shared/utils/src/singleton';
import { config } from '../config';

export const cache = singleton(() => cacheClient(clientConfig(config())));
